export const rowData = [
    {
        name: '空调控制',
        api: '/api/water/ctrl/controlAirConditioning',
        formData: [
            {
                label: '空调序号',
                prop: 'ACIndex',
                show: false,
                value: '1',
            },
            {
                label: '空调开关',
                prop: 'ACStatus',
                show: true,
                type: 'Radio',
                options: [
                    {
                        label: '开启',
                        value: '1',
                    },
                    {
                        label: '关闭',
                        value: '0',
                    },
                ],
            },
            {
                label: '空调模式',
                prop: 'ACMode',
                show: true,
                // rules:{ required: true, message: '请选择', trigger: 'change' },
                type: 'Select',
                options: [
                    {
                        label: '送风',
                        value: '0',
                    },
                    {
                        label: '制冷',
                        value: '1',
                    },
                    {
                        label: '制热',
                        value: '2',
                    },
                    {
                        label: '除霜',
                        value: '3',
                    },
                ],
            },
            {
                label: '温度',
                prop: 'temp',
                show: true,
                type: 'Input',
                placeholder: '设置空调的温度',
                append: '℃',
            },
        ],
    },
    {
        name: '开关门设置',
        api: '/api/water/ctrl/controlDoor',
        formData: [
            {
                label: '开关门',
                prop: 'doorSwitch',
                show: true,
                type: 'Radio',
                options: [
                    {
                        label: '关闭',
                        value: '0',
                    },
                    {
                        label: '开启',
                        value: '1',
                    },
                ],
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
        ],
    },
    {
        name: '提取留样器（实时）信息',
        api: '/api/water/rtd/getSamplerInfo',
        inline: true,
        isTable: false,
        resData: [
            {
                prop: 'dataTime',
                label: '水样时间',
                type: 'string',
            },
            {
                prop: 'samplerType',
                label: '留样类型',
                type: 'object',
                object: {
                    '0': '常规留样',
                    '1': '超标留样',
                    '2': '远程留样',
                    '3': '其它',
                },
            },
            {
                prop: 'workStatus',
                label: '运行模式',
                type: 'object',
                object: {
                    '0': '自动',
                    '1': '手动',
                },
            },
            {
                prop: 'samplerTime',
                label: '留样时间',
                type: 'string',
            },
            {
                prop: 'bottleNum',
                label: '留样瓶号',
                type: 'string',
            },
            {
                prop: 'alarm',
                label: '告警',
                type: 'string',
            },
            {
                prop: 'nextBottleNum',
                label: '下次留样瓶号',
                type: 'string',
            },
            {
                prop: 'polID',
                label: '监测项目',
                type: 'string',
            },
            {
                prop: 'sampleVolume',
                label: '留样体积',
                type: 'string',
                unit: 'ml',
            },
        ],
        formData: [
            {
                label: '水样时间',
                prop: 'dataTime2',
                model: 'dataTime',
                type: 'DatePicker',
                valueType: 'yyyy-MM-dd HH:mm:ss',
                format: 'yyyy-MM-dd',
                dataType: 'date',
                show: true,
                rules: { required: true, type: 'date', message: '请选择', trigger: 'change' },
            },
            {
                label: '留样类型',
                prop: 'samplerType',
                show: true,
                rules: { required: true, message: '请选择', trigger: 'change' },
                type: 'Select',
                options: [
                    {
                        label: '常规留样',
                        value: '0',
                    },
                    {
                        label: '超标留样',
                        value: '1',
                    },
                    {
                        label: '远程留样',
                        value: '2',
                    },
                    {
                        label: '其它',
                        value: '3',
                    },
                ],
            },
            {
                label: '运行模式',
                prop: 'workStatus',
                show: true,
                type: 'Radio',
                rules: { required: true, message: '请选择', trigger: 'change' },
                options: [
                    {
                        label: '手动',
                        value: '1',
                    },
                    {
                        label: '自动',
                        value: '0',
                    },
                ],
            },
            {
                label: '留样时间',
                prop: 'samplerTime2',
                model: 'samplerTime',
                valueType: 'yyyy-MM-dd HH:mm:ss',
                type: 'DatePicker',
                format: 'yyyy-MM-dd',
                dataType: 'date',
                show: true,
                rules: { required: true, type: 'date', message: '请选择', trigger: 'change' },
            },
            {
                label: '留样瓶号',
                prop: 'bottleNum',
                show: true,
                type: 'Input',
                placeholder: '',
                rules: { required: true, message: '请输入', trigger: 'change' },
            },
            {
                label: '告警',
                prop: 'alarm',
                show: true,
                type: 'Input',
                placeholder: '',
                rules: { required: true, message: '请输入', trigger: 'change' },
            },
            {
                label: '下次留样瓶号',
                prop: 'nextBottleNum',
                show: true,
                type: 'Input',
                placeholder: '',
            },
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                // rules: { required: true, message: '请选择', trigger: 'change' },
                api: 'siteComponent',
            },
            {
                label: '留样体积',
                prop: 'sampleVolume',
                show: true,
                type: 'Input',
                placeholder: '',
                append: 'ml',
            },
        ],
    },
    // {
    //     name: '提取留样器（历史）信息',
    //     api: '/api/water/his/getSamplerList',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '20',
    //         },
    //     ],
    // },
    {
        name: '提取试剂存储状态（实时）信息',
        api: '/api/water/rtd/getReagentInfo',
        inline: true,
        isTable: false,
        resData: [
            {
                prop: 'polId',
                label: '测量因子',
                type: 'string',
            },
            {
                prop: 'workTemp',
                label: '试剂冷藏箱温度',
                type: 'string',
                toFiexd: 1,
                unit: '℃',
            },
            {
                prop: 'changeTime',
                label: '试剂更换时间',
                type: 'string',
            },
            {
                prop: 'shelfLife',
                label: '试剂保质期',
                type: 'string',
            },
            {
                prop: 'reagentExcess',
                label: '试剂余量',
                type: 'string',
                unit: '%',
            },
            {
                prop: 'excessDays',
                label: '试剂余量使用天数',
                type: 'string',
                unit: 'd',
            },
        ],
        formData: [],
    },
    {
        name: '远程控制标样核查测试',
        api: '/api/water/ctrl/controlStandardSampleMeasure',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                api: 'siteComponent',
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
            {
                label: '核查类型',
                prop: 'type',
                show: true,
                type: 'Select',
                options: [
                    {
                        label: '低浓度标样核查',
                        value: '1',
                    },
                    {
                        label: '标样核查',
                        value: '2',
                    },
                    {
                        label: '高浓度标样核查',
                        value: '3',
                    },
                ],
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
        ],
    },
    {
        name: '远程启动系统/仪器测试',
        api: '/api/water/ctrl/controlWaterMeasure',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                api: 'siteComponent',
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
            {
                label: '类型',
                prop: 'type',
                show: true,
                type: 'Select',
                options: [
                    {
                        label: '全流程测试',
                        value: '1',
                    },
                    {
                        label: '仪器测试',
                        value: '2',
                    },
                ],
                rules: { required: true, message: '请选类型', trigger: 'change' },
            },
        ],
    },
    {
        name: '远程控制仪表（空白/标样）校准测试',
        api: '/api/water/ctrl/controlCalibrateMeasure',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                api: 'siteComponent',
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
            {
                label: '校准类型',
                prop: 'type',
                show: true,
                type: 'Select',
                options: [
                    {
                        label: '空白校准',
                        value: '1',
                    },
                    {
                        label: '标样校准',
                        value: '2',
                    },
                ],
                rules: { required: true, message: '请选类型', trigger: 'change' },
            },
        ],
    },
    {
        name: '提取取水单元（实时）信息',
        api: '/api/water/rtd/getWaterPointInfo',
        inline: true,
        formData: [],
        isTable: false,
        resData: [
            {
                prop: 'dataTime',
                label: '采样时间',
                type: 'string',
            },
            {
                prop: 'duration',
                label: '实际采水时长',
                type: 'string',
                unit: 'min',
            },
            {
                prop: 'waterPoint',
                label: '取水位置',
                type: 'object',
                object: {
                    '0': '正常',
                    '1': '异常',
                },
            },
            {
                prop: 'floatingDebris',
                label: '取水点漂浮物',
                type: 'object',
                object: {
                    '0': '无',
                    '1': '有',
                },
            },
            {
                prop: 'currentPump',
                label: '当前采水泵',
                type: 'object',
                object: {
                    '0': '1#',
                    '1': '2#',
                },
            },
            {
                prop: 'pumpRunMode',
                label: '采水泵运行模式',
                type: 'object',
                object: {
                    '0': '双泵交替',
                    '1': '只用泵一',
                    '2': '只用泵二',
                },
            },
            {
                prop: 'pumpStatus',
                label: '采水泵工作状态',
                type: 'object',
                object: {
                    '0': '空闲',
                    '1': '工作',
                },
            },
            {
                prop: 'pump1Days',
                label: '采水泵1累计使用天数',
                type: 'string',
                unit: 'd',
            },
            {
                prop: 'pump2Days',
                label: '采水泵2累计使用天数',
                type: 'string',
                unit: 'd',
            },
            {
                prop: 'alarm',
                label: '告警状态',
                type: 'object',
                object: {
                    '0': '无',
                    '1': '取水点偏移',
                    '2': '采水设备丢失',
                    '3': '水泵1/2#故障',
                    '4': '管路堵塞或破损',
                    '5': '人为干扰',
                    '6': '采水头搁浅',
                },
            },
            {
                prop: 'advise',
                label: '告警处理建议',
                type: 'string',
            },
            {
                prop: 'imgPath',
                label: '图片',
                type: 'string',
            },
            {
                prop: 'videoPath',
                label: '视频',
                type: 'string',
            },
            {
                prop: 'waterColor',
                label: '水体颜色',
                type: 'object',
                object: {
                    '0': '清澈',
                    '1': '浑浊',
                    '2': '有色',
                },
            },
            {
                prop: 'rainfall',
                label: '是否降雨',
                type: 'object',
                object: {
                    '0': '否',
                    '1': '是',
                },
            },
            {
                prop: 'waterDepth',
                label: '断面水位',
                type: 'string',
                unit: 'm',
                toFiexd: 2,
            },
            {
                prop: 'pumpWorkTime',
                label: '采水泵累计工作时长',
                type: 'string',
                unit: 'd',
            },
            {
                prop: 'pumpVoltage',
                label: '采水泵工作电压',
                type: 'string',
                unit: 'V',
                toFiexd: 2,
            },
            {
                prop: 'pumpCurrent',
                label: '采水泵工作电流',
                type: 'string',
                unit: 'A',
                toFiexd: 3,
            },
            {
                prop: 'flow',
                label: '采水瞬时流量',
                type: 'string',
                unit: 'L/min',
                toFiexd: 2,
            },
            {
                prop: 'pressure',
                label: '采水压力',
                type: 'string',
                unit: 'KPa',
            },
            {
                prop: 'tankStatus',
                label: '沉淀池液位状态',
                type: 'object',
                object: {
                    '0': '异常',
                    '1': '正常',
                },
            },
            {
                prop: 'fiveTankStatus',
                label: '五参数池液位状态',
                type: 'object',
                object: {
                    '0': '异常',
                    '1': '正常',
                },
            },
            {
                prop: 'tankValue',
                label: '沉淀池液位值',
                type: 'string',
                unit: '%',
            },
            {
                prop: 'realWaterDeep',
                label: '实际采水深度',
                type: 'string',
                unit: 'm',
                toFiexd: 1,
            },
        ],
    },
    {
        name: '提取数采仪（实时）状态',
        api: '/api/water/rtd/getControlInfo',
        inline: true,
        isTable: false,
        resData: [
            {
                prop: 'runStatus',
                label: '工作状态',
                type: 'object',
                object: {
                    '0': '运行',
                    '1': '待机',
                    '2': '故障',
                    '3': '维护',
                },
            },
            {
                prop: 'userStatus',
                label: '用户状态',
                type: 'object',
                object: {
                    '0': '普通用户',
                    '1': '管理员',
                    '2': '维护人员',
                },
            },
            {
                prop: 'runMode',
                label: '运行模式',
                type: 'object',
                object: {
                    '0': '维护模式',
                    '1': '常规（间歇）模式',
                    '2': '应急（连续）模式',
                    '3': '质控模式',
                },
            },
            {
                prop: 'systemTime',
                label: '系统时间',
                type: 'string',
            },
            {
                prop: 'memory',
                label: '内存使用率',
                type: 'string',
                unit: '%',
            },
            {
                prop: 'CPU',
                label: 'CPU使用率',
                type: 'string',
                unit: '%',
            },
            {
                prop: 'diskSpace',
                label: '硬盘剩余空间',
                type: 'string',
                unit: 'G',
                toFiexd: 1,
            },
        ],
        formData: [],
    },
    {
        name: '远程重启现场数采仪',
        api: '/api/water/ctrl/controlReStart',
        onlyRequest: true,
    },
    // {
    //     name: '提取预处理信息（历史）信息',
    //     api: '/api/water/his/getPretreatmentLis',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取实时数据信息',
    //     api: '/api/water/his/getRtdData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取小时数据信息',
    //     api: '/api/water/his/getHourData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取样核查数据信息',
    //     api: '/api/water/his/getCheckData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取低浓度标样核查数据',
    //     api: '/api/water/his/getZeroData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取高浓度标样核查数据',
    //     api: '/api/water/his/getHighData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取加标回收数据',
    //     api: '/api/water/his/getMixData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    // {
    //     name: '提取平行样数据',
    //     api: '/api/water/his/getParallelData',
    //     inline: true,
    //     formData: [
    //         {
    //             label: '请求编码',
    //             prop: 'QN',
    //             show: false,
    //             // "20241201080100001" ===> 年月日时分秒毫秒
    //             value: () => `${new Date().toLocaleString().replace(/[/:\s*\u4e00-\u9fa5]/g, '')}${new Date().getMilliseconds()}`,
    //         },
    //         {
    //             label: '时间',
    //             prop: 'time',
    //             type: 'DatePicker',
    //             valueType:'yyyy-MM-dd HH:mm:ss',
    //             format: 'yyyy-MM-dd',
    //             dataType: 'daterange',
    //             start: 'beginTime',
    //             end: 'endTime',
    //             show: true,
    //             value: [],
    //             rules: {
    //                 type: 'array',
    //                 required: true,
    //                 fields: {
    //                     0: { type: 'date', required: true, message: '请选择起止日期' },
    //                     1: { type: 'date', required: true, message: '请选择起止日期' },
    //                 },
    //             },
    //         },
    //         {
    //             label: '当前页',
    //             prop: 'pageNum',
    //             show: false,
    //             value: '1',
    //         },
    //         {
    //             label: '页面大小',
    //             prop: 'pageSize',
    //             show: false,
    //             value: '99999',
    //         },
    //     ],
    // },
    {
        name: '远程设置监控频次',
        api: '/api/water/settings/monitorFrequency',
        formData: [
            {
                label: '时间',
                prop: 'frequency',
                show: true,
                type: 'Input',
                placeholder: '0-23 小时中间","号隔开',
                rules: { required: true, message: '请输入', trigger: 'change' },
            },
        ],
    },
    {
        name: '远程启动加标回收',
        api: '/api/water/start/addingStandardRecovery',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                rules: { required: true, message: '请选择', trigger: 'change' },
                api: 'siteComponent',
            },
        ],
    },
    {
        name: '远程启动平行样测试',
        api: '/api/water/start/uplicateSamples',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                rules: { required: true, message: '请选择', trigger: 'change' },
                api: 'siteComponent',
            },
        ],
    },
    {
        name: '远程启动标一校准',
        api: '/api/water/start/standardOneCheck',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                rules: { required: true, message: '请选择', trigger: 'change' },
                api: 'siteComponent',
            },
        ],
    },
    {
        name: '远程启动标二校准',
        api: '/api/water/start/standardTwoCheck',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                rules: { required: true, message: '请选择', trigger: 'change' },
                api: 'siteComponent',
            },
        ],
    },
    {
        name: '远程启动盲样流程',
        api: '/api/water/start/blindSampleControl',
        formData: [
            {
                label: '测量因子',
                prop: 'polId',
                show: true,
                type: 'Select',
                api: 'siteComponent',
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
            {
                label: '质控仪因子',
                prop: 'zkyPolId',
                show: true,
                type: 'Select',
                api: 'siteComponent',
                rules: { required: true, message: '请选择', trigger: 'change' },
            },
            {
                label: '稀释比例',
                prop: 'dilutionRatio',
                show: true,
                type: 'Input',
                rules: { required: true, message: '请输入', trigger: 'change' },
            },
        ],
    },
    {
        name: '远程设置系统时间',
        api: '/api/water/settings/systemTime',
        formData: [
            {
                label: '时间',
                prop: 'dataTime2',
                model: 'dataTime',
                valueType: 'yyyyMMddHHmmss', //时间年月日时分秒字符串
                type: 'DatePicker',
                format: 'yyyy-MM-dd HH:mm:ss',
                dataType: 'datetime',
                show: true,
                rules: { required: true, type: 'date', message: '请选择', trigger: 'change' },
            },
        ],
    },
    {
        name: '远程启动采样器留样',
        api: '/api/water/start/samplingSample',
        onlyRequest: true,
    },
    {
        name: '远程启动采样器复位',
        api: '/api/water/start/samplerReset',
        onlyRequest: true,
    },
    {
        name: '水泵管路运行方式切换',
        api: '/api/water/start/PumpPipelineSwitching',
        formData: [
            {
                label: '管路运行方式',
                prop: 'mode',
                show: true,
                type: 'Radio',
                options: [
                    {
                        label: '一备一用',
                        value: '1',
                    },
                    {
                        label: '双泵交替',
                        value: '0',
                    },
                ],
                rules:{ required: true, message: '请选择', trigger: 'change' },
            },
        ],
    },
];
